/* Naturiglow FR — behaviours for the ng-* sections: before/after sliders, count-up figures, landing sticky button. */
(function () {
  if (window.__ngInit) return; window.__ngInit = true;
  function init(scope) {
    scope.querySelectorAll('.ng-ba input[type=range]').forEach(function (r) {
      if (r.__ng) return; r.__ng = true;
      r.addEventListener('input', function () { r.parentNode.style.setProperty('--x', r.value + '%'); });
    });
    var nums = scope.querySelectorAll('[data-ng-count]');
    if (nums.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return; io.unobserve(e.target);
          var el = e.target, end = parseInt(el.dataset.ngCount, 10) || 0, t0 = null;
          (function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1200); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + '%'; if (k < 1) requestAnimationFrame(step); })(performance.now());
        });
      }, { threshold: .5 });
      nums.forEach(function (n) { if (n.__ng) return; n.__ng = true; io.observe(n); });
    }
    scope.querySelectorAll('[data-ng-sticky]').forEach(function (bar) {
      if (bar.__ng) return; bar.__ng = true;
      var start = document.querySelector(bar.dataset.ngStart || 'h1'), end = document.querySelector(bar.dataset.ngEnd || '#ng-cta');
      if (!start) return;
      // position check on scroll (rAF-throttled): robust to fast flings that skip IntersectionObserver thresholds
      var queued = false;
      function upd() { queued = false; var past = start.getBoundingClientRect().bottom < 0, near = end ? end.getBoundingClientRect().top < innerHeight : false; bar.classList.toggle('on', past && !near); }
      addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(upd); } }, { passive: true });
      upd();
    });
  }
  if (document.readyState !== 'loading') init(document); else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
